import * as joint from 'jointjs';

const erd = joint.shapes.erd;

// Define a specific highligthing path for every shape.

erd.Attribute.prototype.getHighlighterPath = function (w, h) {
  return [
    'M',
    0,
    h / 2,
    'A',
    w / 2,
    h / 2,
    '0 1,0',
    w,
    h / 2,
    'A',
    w / 2,
    h / 2,
    '0 1,0',
    0,
    h / 2,
  ].join(' ');
};

erd.Entity.prototype.getHighlighterPath = function (w, h) {
  return ['M', w, 0, w, h, 0, h, 0, 0, 'z'].join(' ');
};

erd.Relationship.prototype.getHighlighterPath = function (w, h) {
  return ['M', w / 2, 0, w, w / 2, w / 2, w, 0, w / 2, 'z'].join(' ');
};

erd.ISA.prototype.getHighlighterPath = function (w, h) {
  return ['M', -8, 1, w + 8, 1, w / 2, h + 2, 'z'].join(' ');
};

// Define a specific connection points for every shape

erd.Attribute.prototype.getConnectionPoint = function (referencePoint) {
  // Intersection with an ellipse
  return joint.g.Ellipse.fromRect(
    this.getBBox()
  ).intersectionWithLineFromCenterToPoint(referencePoint);
};

erd.Entity.prototype.getConnectionPoint = function (referencePoint) {
  // Intersection with a rectangle
  return this.getBBox().intersectionWithLineFromCenterToPoint(referencePoint);
};

erd.Relationship.prototype.getConnectionPoint = function (referencePoint) {
  // Intersection with a rhomb
  var bbox = this.getBBox();
  var line = new joint.g.Line(bbox.center(), referencePoint);
  return (
    line.intersection(new joint.g.Line(bbox.topMiddle(), bbox.leftMiddle())) ||
    line.intersection(
      new joint.g.Line(bbox.leftMiddle(), bbox.bottomMiddle())
    ) ||
    line.intersection(
      new joint.g.Line(bbox.bottomMiddle(), bbox.rightMiddle())
    ) ||
    line.intersection(new joint.g.Line(bbox.rightMiddle(), bbox.topMiddle()))
  );
};

erd.ISA.prototype.getConnectionPoint = function (referencePoint) {
  // Intersection with a triangle
  var bbox = this.getBBox();
  var line = new joint.g.Line(bbox.center(), referencePoint);
  return (
    line.intersection(new joint.g.Line(bbox.origin(), bbox.topRight())) ||
    line.intersection(new joint.g.Line(bbox.origin(), bbox.bottomMiddle())) ||
    line.intersection(new joint.g.Line(bbox.topRight(), bbox.bottomMiddle()))
  );
};

// Exported Functions

const createEntity = function (entityName, position = { x: 100, y: 200 }) {
  return new erd.Entity({
    position: { x: position.x, y: position.y },
    attrs: {
      text: {
        fill: '#ffffff',
        text: entityName,
        letterSpacing: 0,
        style: { textShadow: '1px 0 1px #333333' },
      },
      '.outer': {
        fill: '#31d0c6',
        stroke: 'none',
        filter: {
          name: 'dropShadow',
          args: { dx: 0.5, dy: 2, blur: 2, color: '#333333' },
        },
      },
      '.inner': {
        fill: '#31d0c6',
        stroke: 'none',
        filter: {
          name: 'dropShadow',
          args: { dx: 0.5, dy: 2, blur: 2, color: '#333333' },
        },
      },
    },
  });
};

const createWeek = function (name, position = { x: 530, y: 200 }) {
  return new erd.WeakEntity({
    position: { x: position.x, y: position.y },
    attrs: {
      text: {
        fill: '#ffffff',
        text: name,
        letterSpacing: 0,
        style: { textShadow: '1px 0 1px #333333' },
      },
      '.inner': {
        fill: '#31d0c6',
        stroke: 'none',
        points: '155,5 155,55 5,55 5,5',
      },
      '.outer': {
        fill: 'none',
        stroke: '#ff0000',
        points: '160,0 160,60 0,60 0,0',
        filter: {
          name: 'dropShadow',
          args: { dx: 0.5, dy: 2, blur: 2, color: '#333333' },
        },
      },
    },
  });
};

const createAnnotatedRelation = function (name, position = { x: 300, y: 900 }) {
  return new erd.IdentifyingRelationship({
    position: { x: position.x, y: position.y },
    attrs: {
      text: {
        fill: '#ffffff',
        text: name,
        letterSpacing: 0,
        style: { textShadow: '1px 0 1px #333333' },
      },
      '.inner': {
        fill: '#797d9a',
        stroke: 'none',
      },
      '.outer': {
        fill: 'none',
        stroke: '#ff0000',
        filter: {
          name: 'dropShadow',
          args: { dx: 0, dy: 2, blur: 1, color: '#333333' },
        },
      },
    },
  });
};

const createRelation = function (relationName, position = { x: 300, y: 390 }) {
  return new erd.Relationship({
    position: { x: position.x, y: position.y },
    attrs: {
      text: {
        fill: '#ffffff',
        text: relationName,
        letterSpacing: 0,
        style: { textShadow: '1px 0 1px #333333' },
      },
      '.outer': {
        fill: '#797d9a',
        stroke: 'none',
        filter: {
          name: 'dropShadow',
          args: { dx: 0, dy: 2, blur: 1, color: '#333333' },
        },
      },
    },
  });
};

const createKey = function (keyName, position = { x: 10, y: 10 }) {
  return new erd.Key({
    position: { x: position.x, y: position.y },
    attrs: {
      text: {
        fill: '#ffffff',
        text: keyName,
        letterSpacing: 0,
        style: { textShadow: '1px 0 1px #333333' },
      },
      '.outer': {
        fill: '#feb662',
        stroke: 'none',
        filter: {
          name: 'dropShadow',
          args: { dx: 0, dy: 2, blur: 2, color: '#222138' },
        },
      },
      '.inner': {
        fill: '#feb662',
        stroke: 'none',
      },
    },
  });
};

const createNormalPropoerty = function (propName, position = { x: 75, y: 30 }) {
  return new erd.Normal({
    position: { x: position.x, y: position.y },
    attrs: {
      text: {
        fill: '#ffffff',
        text: propName,
        letterSpacing: 0,
        style: { textShadow: '1px 0 1px #333333' },
      },
      '.outer': {
        fill: '#fe8550',
        stroke: '#fe854f',
        filter: {
          name: 'dropShadow',
          args: { dx: 0, dy: 2, blur: 2, color: '#222138' },
        },
      },
    },
  });
};

const createPrimaryConnector = function (position = { x: 150, y: 90 }) {
  return new erd.Multivalued({
    position: { x: position.x, y: position.y },
    size: { width: 25, height: 25 },
    attrs: {
      text: {
        fill: '#ffffff',
        text: '',
        letterSpacing: 0,
        style: { 'text-shadow': '1px 0px 1px #333333' },
      },
      '.inner': {
        fill: '#2D0106',
        stroke: 'none',
        rx: 43,
        ry: 21,
      },
      '.outer': {
        fill: '#2D0106',
        stroke: '#ffffff',
        filter: {
          name: 'dropShadow',
          args: { dx: 0, dy: 2, blur: 2, color: '#ffffff' },
        },
      },
    },
  });
};

const createLink = function (elm1, elm2, graph) {
  const myLink = new erd.Line({
    markup: [
      '<path class="connection" stroke="black" d="M 0 0 0 0"/>',
      '<path class="connection-wrap" d="M 0 0 0 0"/>',
      '<g class="labels"/>',
      '<g class="marker-vertices"/>',
      '<g class="marker-arrowheads"/>',
    ].join(''),
    source: { id: elm1.id ? elm1.id : elm1.getId() },
    target: { id: elm2.id ? elm2.id : elm2.getId() },
  });

  return myLink.addTo(graph);
};

const createLabel = function (txt) {
  return {
    labels: [
      {
        position: -20,
        attrs: {
          text: { dy: -8, text: txt, fill: '#ffffff' },
          rect: { fill: 'none' },
        },
      },
    ],
  };
};

export {
  createEntity,
  createWeek,
  createAnnotatedRelation,
  createRelation,
  createKey,
  createPrimaryConnector,
  createNormalPropoerty,
  createLink,
  createLabel,
};
